import TransactionModal from "./transactionModal.js";
import { $_GET } from "../globalFunctions.js";

export default class AddPoolModal extends TransactionModal {
  constructor(companyId, show) {
    super("add-pool-modal", companyId, show);

    this.$amountType = this.$form.querySelector('[name="amount-type"]');
    this.$date = this.$form.querySelector('[name="date"]');

    this.formFields = [
      {
        name: "id",
        varType: "int",
      },
      {
        name: "name",
        varType: "string",
        required: true,
      },
      {
        name: "amount",
        varType: "int",
        required: true,
        trigger: "input",
      },
      {
        name: "date",
        varType: "string",
        required: true,
      },
      {
        name: "share_class",
        varType: "int",
        required: true,
      },
      {
        name: "documents",
        varType: "simple-array",
        type: "int",
      },
      {
        name: "notes",
      },
    ];

    this.setupForm();
    Promise.all([
      this.documentsPromise,
      this.setupShareClasses(),
      this.getSharesCount(),
    ]).then((result) => {
      this.whenReady();
    });
  }

  setupForm() {
    this.$date.valueAsDate = new Date();
    this.$date.addEventListener("change", () => {
      this.getSharesCount();
    });

    this.$form
      .querySelector('[name="amount"]')
      .addEventListener("input", () => {
        this.showPercent();
      });

    this.$amountType.addEventListener("input", () => {
      this.showPercent();
    });
  }

  showPercent() {
    // no shares set yet, cant calculate anything
    if (this.totalShares < 1) {
      this.$form.querySelector("[data-percent]").classList.add("d-none");
      return;
    } else {
      this.$form.querySelector("[data-percent]").classList.remove("d-none");
    }
    let amount = this.getInt("amount");
    let typeWord;
    let val;

    if (this.isTypingShares()) {
      typeWord = "%";
      val = (amount * 100) / (this.getTotalShares() + amount);
    } else {
      amount = Math.abs(amount);
      if (amount > 100) {
        // its a %
        amount = 100;
        this.setInt("amount", amount);
      }
      typeWord = trans("shares");
      val = this.calculateSharesIncludingDilution(amount);
    }

    this.$form.querySelector("[data-percent] span").innerText = typeWord;
    this.$form.querySelector("[data-percent] i").innerText =
      typeof val !== "number" || isNaN(val) ? "??" : peque.formatNumber(val);
  }

  calculateSharesIncludingDilution(expectedPercentage) {
    /*
		 totalShares - (100% - expectedPercentage)
			 x?      - expectedPercentage
		* */
    return parseInt(
      Math.round(
        (expectedPercentage * this.getTotalShares()) /
          (100 - expectedPercentage)
      )
    );
  }

  getSharesCount() {
    return new Promise((resolve, reject) => {
      peque
        .api(
          "shares/count",
          {
            company: this.companyId,
            simulation: $_GET("simulation"),
            date: this.$date.value,
          },
          "get"
        )
        .then((response) => {
          this.totalShares = response.result ? response.result.total : 0;
          this.showPercent();
          resolve(this.totalShares);
        });
    });
  }

  isTypingShares() {
    return this.$amountType.value === "shares";
  }

  getTotalShares() {
    let shares = this.totalShares;

    // we have to remove the current pool size to avoid miscalculations when editing an existing pool
    // happens when editing an existing entry aka there are already issued shares for the pool transaction
    if (this.currentData !== null && this.currentData.amount) {
      shares -= this.currentData.amount;
    }
    return shares;
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);

    this.getFields(this.formFields)
      .then((data) => {
        data.company = this.companyId;
        data.simulation =
          typeof window.pequeData.simulation === "undefined"
            ? $_GET("simulation")
            : window.pequeData.simulation;
        data.type = peque.TRANSACTION_TYPE_POOL_CREATION;

        if (!this.isTypingShares()) {
          data.amount = this.calculateSharesIncludingDilution(data.amount);
        }

        peque
          .api("transactions", JSON.stringify(data), "post")
          .then((response) => {
            this.mutateReactTransactions();
          })
          .catch((response) => {
            this.enableSubmitButton(true);

            switch (response.error) {
              case peque.ERROR_DUPLICATED_ENTRY:
                this.showErrorOnField(
                  "Name already in use",
                  this.$form.querySelector('[name="name"]')
                );
                break;
            }
          });
      })
      .catch((error) => {
        this.enableSubmitButton(true);

        if (typeof error.el === "undefined") {
          console.error(error);
          return;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
